import React from "react"
import PropTypes from "prop-types"
import "./TableFooter.scss"
import { maybePluralize } from "../../helpers/sharedHelperFunctions"

const TableFooter = ({ dataCount, wrapperHeight, rowHeight, children }) => {
  const footerClass = () => {
    const totalResultsHeight = rowHeight * dataCount
    if (totalResultsHeight > wrapperHeight - 32) return "with-shadow"
  }

  return (
    <div className={`TableFooter ${wrapperHeight && footerClass()}`}>
      <div className="left">{maybePluralize(dataCount, "result")}</div>
      <div className="right">{children}</div>
    </div>
  )
}

TableFooter.propTypes = {
  wrapperHeight: PropTypes.number,
  rowHeight: PropTypes.number.isRequired,
  dataCount: PropTypes.number.isRequired,
  /* Children show up on the right side of the footer */
  children: PropTypes.node,
}

export default TableFooter
